module.exports = __webpack_public_path__ + "img/logo2.42a81d15.jpg";